<script>
import bem from '@/utils/bem';
import TemplateFrameOptions from '@/components/frames/TemplateFrameOptions.vue';
import TemplateFrameOptionDisplays from '@/components/frames/TemplateFrameOptionDisplays.vue';
import { mapActions } from 'vuex';

const b = bem('template-frame-details');

export default {
  data() {
    return {
      selectedOption: {},
    };
  },
  components: {
    TemplateFrameOptions,
    TemplateFrameOptionDisplays,
  },
  props: {
    selectedCollection: {
      type: Object,
      required: true,
    },
    isShowOptions: Boolean,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getFrameOptionDisplaysAction: 'createTemplate/getFrameOptionDisplays',
    }),
    toggleOptionDisplays(value, option) {
      if (!value) {
        this.getFrameOptionDisplaysAction({ productId: option.id });
      }
      this.selectedOption = option;
      this.$emit('update:isShowOptions', value);
    },
  },
};
</script>

<template>
  <div :class="b('')">
    <TemplateFrameOptions
        v-if="isShowOptions"
        :selected-collection="selectedCollection"
        :toggle-option-displays="toggleOptionDisplays"
    />
    <TemplateFrameOptionDisplays
        v-else
        :toggle-option-displays="toggleOptionDisplays"
        :selected-option="selectedOption"
    />
  </div>
</template>
